import {
  DEFAULT_PROPS,
  DRAWER_HEADER_ACTIONS_ATTRIBUTE,
  DRAWER_HEADER_ACTIONS_WIDTH_VAR,
  OVERLINE_STYLES,
} from './const';
import { DRAWER_PARTS } from './drawerParts';
import type { DrawerStyleConfig } from './types';

const baseStyle: DrawerStyleConfig['baseStyle'] = ({ isFullHeight }) => {
  return {
    overlay: {
      bg: 'overlay.drawer',
      zIndex: 'modal',
    },
    dialogContainer: {
      display: 'flex',
      zIndex: 'modal',
      justifyContent: 'center',
    },
    dialog: {
      height: isFullHeight ? '100vh' : undefined,
      zIndex: 'modal',
      maxH: '100vh',
      bg: 'page.surface',
      color: 'inherit',
      boxShadow: 'drawer',
      // Reserve room for the absolutely positioned close button (and move any
      // DrawerHeaderActions slot to sit to its left).
      '&:has(.chakra-modal__close-btn) .chakra-modal__header': {
        pe: `calc(var(--chakra-space-9) + var(${DRAWER_HEADER_ACTIONS_WIDTH_VAR}, 0px))`,
      },
      [`&:has(.chakra-modal__close-btn) [${DRAWER_HEADER_ACTIONS_ATTRIBUTE}]`]:
        {
          insetEnd: 7,
        },
    },
    header: {
      borderBottom: '1px solid',
      borderBottomColor: 'separator.divider',
      fontSize: 'lg',
      lineHeight: 'lg',
      fontWeight: 'heavy',
      p: 2,
      pe: `calc(var(--chakra-space-2) + var(${DRAWER_HEADER_ACTIONS_WIDTH_VAR}, 0px))`,
    },
    overline: OVERLINE_STYLES,
    headerActions: {
      position: 'absolute',
      top: '0.875rem',
      insetEnd: '0.875rem',
      display: 'flex',
      alignItems: 'center',
      gap: 1,
    },
    closeButton: {
      position: 'absolute',
      top: '0.875rem',
      insetEnd: '0.875rem',
      color: 'feature.secondary',
    },
    body: {
      px: 2,
      py: 1.5,
      fontSize: 'md',
      lineHeight: 'md',
      flex: 1,
      overflow: 'auto',
    },
    footer: {
      borderTop: '1px solid',
      borderTopColor: 'separator.divider',
      px: 2,
      py: 1.5,
    },
  };
};

const SIZES = {
  sm: { dialog: { maxW: '25rem' } },
  md: { dialog: { maxW: '32.5rem' } },
  lg: { dialog: { maxW: '40rem' } },
};

export const DRAWER_STYLE_CONFIG: DrawerStyleConfig = {
  parts: DRAWER_PARTS,
  baseStyle,
  sizes: SIZES,
  defaultProps: DEFAULT_PROPS,
};
